__turbopack_context__.v({
  "block": "tablet-layout-module-sass-module__CnCjvG__block",
  "container": "tablet-layout-module-sass-module__CnCjvG__container",
});
